import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { Char19o2r8palgjof as Char } from '../Char.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var IntIteratorClass;
function IntIterator() {
  if (IntIteratorClass === VOID) {
    class $ {
      o1() {
        return this.ul();
      }
    }
    initMetadataForClass($, 'IntIterator');
    IntIteratorClass = $;
  }
  return IntIteratorClass;
}
var LongIteratorClass;
function LongIterator() {
  if (LongIteratorClass === VOID) {
    class $ {
      o1() {
        return this.vl();
      }
    }
    initMetadataForClass($, 'LongIterator');
    LongIteratorClass = $;
  }
  return LongIteratorClass;
}
var CharIteratorClass;
function CharIterator() {
  if (CharIteratorClass === VOID) {
    class $ {
      wl() {
        return this.xl();
      }
      o1() {
        return new (Char())(this.wl());
      }
    }
    initMetadataForClass($, 'CharIterator');
    CharIteratorClass = $;
  }
  return CharIteratorClass;
}
//region block: exports
export {
  CharIterator as CharIterator2h6gbyxoj1es2,
  IntIterator as IntIteratordtlvcwxsuu5a,
  LongIterator as LongIterator6nf6jdg4ti4,
};
//endregion

//# sourceMappingURL=PrimitiveIterators.mjs.map
